import script from "./DocumentsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentsPage.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentsPage.vue?vue&type=style&index=0&id=b1fbb822&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1fbb822"]])

export default __exports__